import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-referred',
  templateUrl: './referred.component.html',
})
export class ReferredComponent implements OnInit {
  private _pet_no: number;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getFullReferByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService
  ) {

  }

  ngOnInit() { 
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.petService.setupPetRefer()
      .then(() => {
        Swal.close();

        Swal.fire({
          title: 'Information stored correctly',
          didOpen: () => {
          },
        })
      });
  }
}